import type { WidgetTypeValue } from '~/types/widget';
import type { CatalogMap, ElementSchema } from './types';
import { CART_CATALOG } from './cart-catalog';
import { CLAIM_PORTAL_CATALOG } from './claim-portal-catalog';
import { CLAIM_SELECTOR_CATALOG } from './claim-selector-catalog';

export * from './types';
export {
  CART_CATALOG,
  CART_ELEMENT_TYPES,
  CART_PALETTE_ENTRIES,
  effectiveDirection,
  resolveAxisControl,
  resolveGroupBandLabel,
  withoutOptInElements,
} from './cart-catalog';
export { CLAIM_PORTAL_CATALOG, CLAIM_PORTAL_BLOCK_ORDER, ClaimPortalBlockType } from './claim-portal-catalog';
export { CLAIM_SELECTOR_CATALOG, CLAIM_SELECTOR_BLOCK_ORDER, ClaimSelectorBlockType } from './claim-selector-catalog';
export { INFO_MODAL_CATALOG, INFO_MODAL_BLOCK_ORDER, InfoModalBlockType } from './info-modal-catalog';
export { resolveElementIcon } from './icons';

/**
 * Every claim-portal designer block type across both pages (Welcome + Claim Selector), keyed by type.
 * The inspector resolves a selected node's schema from this merged map regardless of which page it's on.
 */
export const CLAIM_PORTAL_DESIGNER_CATALOG: CatalogMap = { ...CLAIM_PORTAL_CATALOG, ...CLAIM_SELECTOR_CATALOG };

/**
 * Returns the element catalog for a widget type. CART and SUBSCRIPTION share the
 * full free-form catalog. CHECKOUT (constrained, Phase D) is not yet implemented and
 * returns an empty catalog so callers can detect "no visual builder for this type".
 */
export function getCatalog(widgetType: WidgetTypeValue | string | undefined): CatalogMap {
  if (widgetType === 'CHECKOUT') return {};

  return CART_CATALOG;
}

/** Whether the visual builder supports a given widget type at all. */
export function supportsVisualBuilder(widgetType: WidgetTypeValue | string | undefined): boolean {
  return Object.keys(getCatalog(widgetType)).length > 0;
}

/** Looks up the schema for a node type within a catalog (undefined if unknown). */
export function getElementSchema(catalog: CatalogMap, type: string): ElementSchema | undefined {
  return catalog[type];
}

/** Palette entries (addable elements) for a widget type, in catalog order. */
export function getPaletteEntries(widgetType: WidgetTypeValue | string | undefined): ElementSchema[] {
  return Object.values(getCatalog(widgetType)).filter(e => e.paletteVisible);
}
